import {
  CREATE_WORK,
  CREATE_WORK_FAILURE,
  CREATE_WORK_SUCCESS,
  DELETE_WORK,
  DELETE_WORK_FAILURE,
  DELETE_WORK_SUCCESS,
  GET_WORKS,
  GET_WORKS_FAILURE,
  GET_WORKS_SUCCESS,
  GET_SINGLE_WORK,
  GET_SINGLE_WORK_FAILURE,
  GET_SINGLE_WORK_SUCCESS,
  UPDATE_WORK,
  UPDATE_WORK_FAILURE,
  UPDATE_WORK_SUCCESS,
} from "./actionTypes";

export const getWorks = (payload) => {
  return {
    type: GET_WORKS,
    payload,
  };
};

export const getWorksSuccess = (payload) => {
  return {
    type: GET_WORKS_SUCCESS,
    payload,
  };
};

export const getWorksFailure = (payload) => {
  return {
    type: GET_WORKS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const getSingleWork = (payload) => {
  return {
    type: GET_SINGLE_WORK,
    payload,
  };
};

export const getSingleWorkSuccess = (payload) => {
  return {
    type: GET_SINGLE_WORK_SUCCESS,
    payload,
  };
};

export const getSingleWorkFailure = (payload) => {
  return {
    type: GET_SINGLE_WORK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const createWork = (payload) => {
  return {
    type: CREATE_WORK,
    payload,
  };
};

export const createWorkSuccess = (payload) => {
  return {
    type: CREATE_WORK_SUCCESS,
    payload,
  };
};

export const createWorkFailure = (payload) => {
  return {
    type: CREATE_WORK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const updateWork = (payload) => {
  return {
    type: UPDATE_WORK,
    payload,
  };
};

export const updateWorkSuccess = (payload) => {
  return {
    type: UPDATE_WORK_SUCCESS,
    payload,
  };
};

export const updateWorkFailure = (payload) => {
  return {
    type: UPDATE_WORK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const deleteWork = (payload) => {
  return {
    type: DELETE_WORK,
    payload,
  };
};

export const deleteWorkSuccess = (payload) => {
  return {
    type: DELETE_WORK_SUCCESS,
    payload,
  };
};

export const deleteWorkFailure = (payload) => {
  return {
    type: DELETE_WORK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
